import { forwardRef } from 'react';
import type { SVGIconProps } from '../types';

/**
 * Google 公式ブランドロゴ（フルカラーの "G"）。色は公式配色で固定し `color` は無視する。
 * @see https://developers.google.com/identity/branding-guidelines?hl=ja
 */
export const GoogleIcon = forwardRef<SVGSVGElement, SVGIconProps>(({
  size = 16,
  color: _color,
  ...props
}, ref) => <svg ref={ref} width={size} height={size} viewBox="0 0 49 50" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill="#4285F4" d="M48.8993 25.5443C48.8993 23.8596 48.7363 22.1204 48.4645 20.49H24.9319V30.1096H38.4102C37.8667 33.2074 36.0732 35.9248 33.4102 37.6639L41.4536 43.9139C46.1819 39.5117 48.8993 33.0987 48.8993 25.5443Z" />
      <path fill="#34A853" d="M24.932 49.8923C31.6712 49.8923 37.3233 47.664 41.4538 43.8597L33.4102 37.6639C31.1819 39.1856 28.3016 40.0553 24.932 40.0553C18.4103 40.0553 12.9212 35.6531 10.9103 29.7836L2.64944 36.1423C6.88857 44.5662 15.4755 49.8923 24.932 49.8923Z" />
      <path fill="#FBBC05" d="M10.9103 29.7292C9.87774 26.6314 9.87774 23.2618 10.9103 20.164L2.64948 13.751C-0.883131 20.8162 -0.883173 29.1314 2.64944 36.1423L10.9103 29.7292Z" />
      <path fill="#EA4335" d="M24.932 9.89226C28.4647 9.83791 31.9429 11.1966 34.4973 13.6423L41.6168 6.46835C37.106 2.22921 31.1277 -0.0533993 24.932 0.000948526C15.4755 0.000948526 6.88861 5.32706 2.64948 13.751L10.9103 20.164C12.9212 14.2401 18.4103 9.89226 24.932 9.89226Z" />
    </svg>);
GoogleIcon.displayName = 'GoogleIcon';